module.exports = __webpack_public_path__ + "static/device-2-736f4c63813b675f5850eaddacccc061.webp";